import { REQUEST_SCENE_REPROCESSING, RECIEVE_SCENE_REPROCESSING } from '../constants/actionTypes';
import { showReprocessingModal } from './modal';
import { getBody, generateReprocessingDialogText } from './helpers';
import { getBackendUrl } from '../env';


// Action Creators
const requestReprocessScene = scene => ({
    type: REQUEST_SCENE_REPROCESSING,
    scene: scene
});

const recieveReprocessScene = scene => ({
    type: RECIEVE_SCENE_REPROCESSING,
    scene: scene
});

// Action Logic
export const canReprocessScene = sceneMedia => {
    // Can't reprocess a scene with no media
    if (!sceneMedia.mediaItems || !sceneMedia.mediaItems.length) {
        return false;
    }

    // Can't double-reprocess a scene
    if (sceneMedia.reprocessing) {
        return false;
    }

    return true;
};

const reprocessScene = scene => (dispatch) => {
    dispatch(requestReprocessScene(scene));
    return fetch(`${getBackendUrl()}/api/v1/scene/${scene}`, {method: 'PUT'})
        .then(resp => getBody(resp, 301))
        .then(
            json => {
                dispatch(recieveReprocessScene(scene));
                return json.reprocessingCount;
            },
            err => {
                dispatch(recieveReprocessScene(scene));
                return err;
            }
        );
};

export const reprocessSceneIfOK = scene => (dispatch, getState) => {
    const state = getState();
    const sceneMedia = state.mediaByScene[scene];
    
    if (canReprocessScene(sceneMedia)) {
        dispatch(reprocessScene(scene))
            .then(result => generateReprocessingDialogText(new Array(result), 'media items'))
            .then(text => dispatch(showReprocessingModal(text)));
    }
};



// WEBPACK FOOTER //
// ./src/actions/reprocessScene.js